"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildEmailPreviewChipStyle = void 0;
const buildEmailPreviewChipStyle = (tokens) => {
    const borderColor = tokens.isDark ? tokens.bBrand : tokens.bModerate;
    const textColor = tokens.isDark ? tokens.tIntense : tokens.tBrand;
    return `<style>
  [data-custom-variable]:not([data-button-color]), .styled-tag-chip:not([data-button-color]) {
    background-color: ${tokens.sSupershy} !important;
    border: 1px solid ${borderColor} !important;
    border-radius: 9999px;
    color: ${textColor} !important;
    -webkit-text-fill-color: ${textColor} !important;
    display: inline-block;
    margin: 0;
    padding: 2px 8px;
    font-size: 12px;
    line-height: 1.2;
  }
</style>`;
};
exports.buildEmailPreviewChipStyle = buildEmailPreviewChipStyle;
